<template>
    <div class="data-wrapper-core">
        <h3>WhatsApp Messages</h3>
        <v-divider></v-divider>
        <v-expansion-panels>
            <v-expansion-panel v-for="(message, index) in whatsAppMessages" :key="index">
                <v-expansion-panel-title>
                    {{ index +1 }}. WhatsApp Message - {{ new Date(message.createdAt).toLocaleString() }}
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <p><strong>WhatsApp ID:</strong> {{ message.whatsapp_id }}</p>
                    <p><strong>Message:</strong> {{ message.message }}</p>
                    <p><strong>Status:</strong> {{ message.status }}</p>
                    <p><strong>Type:</strong> {{ message.type }}</p>
                    <p><strong>Variables:</strong> {{ message.variables.join(', ') }}</p>
                    <p><strong>Created At:</strong> {{ new Date(message.createdAt.$date).toLocaleString() }}</p>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {

    computed: {
        ...mapState('lead', ['whatsAppMessages']),
    },

}
</script>

<style lang="scss" scoped>
.lead-uploads-divider {
    margin: 12px 0;
}

.subuser-panels {
    margin: 8px 0;
}
</style>